<template>
  <div style="background-color: black">
    <img
      :src="imageUrl"
      style="width: 100%; height: 100%; max-width: 100vw; max-height: 100vh; object-fit: contain"
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      imageUrl: this.$route.query.url,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
